import { Box, LinearProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export default function TemporizadorPix({
    controleTempo = false,
    expiracao = 300
}: TemporizadorPixProps) {

    const [progress, setProgress] = useState(100)
    const [timeLeft, setTimeLeft] = useState(expiracao);

    useEffect(() => {
        if (controleTempo && expiracao) {
            const totalDuration = expiracao * 1000; // 5 minutos em milissegundos
            const interval = 1000; // Atualiza a cada 1 segundo
            const decrement = (100 / (totalDuration / interval)); // Calcula o incremento necessário

            const timer = setInterval(() => {
                setProgress((oldProgress) => {
                    if (oldProgress <= 0) {
                        clearInterval(timer); // Para o intervalo quando o progresso atinge 0%
                        return 100;
                    }
                    return Math.max(oldProgress - decrement, 0);
                });
                setTimeLeft((prevTime) => {
                    if (prevTime <= 1) {
                        clearInterval(timer); // Para o intervalo quando o tempo atinge 0
                        return 0;
                    }
                    return prevTime - 1; // Decrementa o tempo
                });
            }, interval);

            return () => {
                clearInterval(timer);
            };
        }
    }, [controleTempo]);

    return (
        <Box>
            <Typography variant='subtitle2'>O tempo para pagar acaba em:</Typography>
            <Typography variant='h6' fontWeight={'bold'}>{Math.floor(timeLeft / 60)}:{('0' + (timeLeft % 60)).slice(-2)}</Typography>
            <LinearProgress variant="determinate" value={progress} />
        </Box>
    )
}

interface TemporizadorPixProps {
 controleTempo: boolean
 expiracao: number
}